import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Modal, Row, Col } from 'antd';
import { } from "@ant-design/icons";
import { isMobile } from 'react-device-detect';
import { stripHtml, renderAppointmentName, isValidDate, renderAppointmentStatus } from '@/utils/helpers';
import ScheduleDiffTag from '../appointments/ScheduleDiffTag';

class AppointmentHistoryModal extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: false
        };
    }

    onClose() {
        this.props.onCancel();
        this.setState({
            isLoading: false
        });
    }

    render() {
        var { isLoading } = this.state;
        var { visible, currentData } = this.props;

        const columns = [
            {
                title: 'Kiểu lịch hẹn',
                dataIndex: 'name',
                key: 'name',
                width: '200px',
                render: (text, record) => {
                    return (
                        <strong>
                            {renderAppointmentName(record.name)}
                        </strong>
                    )
                }
            },
            {
                title: 'Thời gian',
                dataIndex: 'scheduled_at',
                key: 'scheduled_at',
                width: '140px',
                render: (text, record) => {
                    return (
                        <div>
                            {isValidDate(text)}
                        </div>
                    )
                }
            },
            {
                title: '#',
                width: 100,
                render: (_, record) => (
                    <ScheduleDiffTag date={record.scheduled_at} />
                )
            },
            {
                title: 'Trạng thái',
                dataIndex: 'status',
                key: 'status',
                width: '100px',
                render: (text, record) => {
                    return (
                        <div>{renderAppointmentStatus(text)}</div>
                    )
                }
            },
            {
                title: 'Bác sĩ điều trị',
                dataIndex: 'doctors_text',
                key: 'doctors_text',
                width: '250px',
                render: (text, record) => {
                    return (
                        <div>{record.doctors_text}</div>
                    )
                }
            },
            {
                title: 'Ghi chú',
                dataIndex: 'note',
                key: 'note',
                width: '400px',
                render: (text, record) => {
                    return (
                        <>{stripHtml(text)}</>
                    )
                }
            }
        ];

        return (
            <Modal
                visible={visible}
                title={`Lịch hẹn khách hàng: ${currentData?.full_name} - ${currentData?.code}`}
                onCancel={() => this.onClose()}
                maskClosable={true}
                width={isMobile ? '100%' : '80%'}
                footer={false}
            >
                {visible ?
                    <Row gutter={16}>
                        <Col xs={24} md={24}>
                            <Table
                                size='small'
                                rowKey='key'
                                tableLayout="auto"
                                columns={columns}
                                dataSource={currentData ? currentData.appointments : []}
                                pagination={false}
                                loading={isLoading}
                                scroll={isMobile ? { x: 'max-content' } : undefined}
                                locale={{ emptyText: "Chưa có dữ liệu" }}
                            />
                        </Col>
                    </Row>
                    : null}
            </Modal>
        )
    }
}

export default connect(null, null)((AppointmentHistoryModal));
